import useAuth from "@app/context/AuthContext";
import useFilteredProcedures from "@app/pages/samples/hook/useFilteredProcedures";
import useAnalysis from "@app/pages/samples/utils/useAnalysis";
import { useSample } from "@app/pages/samples/utils/useSample";
import { useEquipment } from "@services/servicesGenericsTables";
import { AnalysisType } from "@services/types";
import { useParams } from "react-router-dom";

export const useDefaultValuesData = (
  typeAnalysis: AnalysisType,
  processingDateTimeEnd: string
) => {
  const { user } = useAuth();
  const { stateSample } = useSample();
  const { sampling } = stateSample;
  const filteredProceduresListPRE = useFilteredProcedures("PRE");
  const filteredProceduresListCON = useFilteredProcedures("CON");
  const filteredCalculationListCAL = useFilteredProcedures("CAL");
  const { idMuestra } = useParams();
  const filteredProceduresPRE = filteredProceduresListPRE?.[0];
  const filteredProceduresCON = filteredProceduresListCON?.[0];
  const filteredCalculationCAL = filteredCalculationListCAL?.[0];

  const {
    currentPreparation,
    currentCounting,
    currentCalculation,
    preparationsList,
  } = useAnalysis();

  const currentPreparationObject = preparationsList.filter((p) =>
    p.analysis_type.map((a) => a.id).includes(typeAnalysis?.id)
  )[currentPreparation.index as number];

  const consultEquipment = (id: number) =>
    useEquipment
      .getState()
      .equipmentList.find((equipment) => equipment.id === id);

  return {
    user,
    sampling,
    filteredProceduresPRE,
    filteredProceduresCON,
    filteredCalculationCAL,
    currentCounting,
    currentCalculation,
    consultEquipment,
    currentPreparationIndex: currentPreparationObject,
    processingDateTimeEnd,
    currentPreparation,
    idMuestra,
  };
};
